import { memo } from "react";
import { Button, Flex } from "@mantine/core";
import ActionCard from "src/components/ActionCard";
import { MdDownload } from "react-icons/md";
import { IoMdEye } from "react-icons/io";
import { CardRadius, HeightCard } from "src/utils/constants";

type ICardReport = {
  title: string;
  handleModal: (bool: boolean) => void;
};

function CardReport({ title, handleModal }: ICardReport) {
  return (
    <div>
      <ActionCard
        title={title}
        mt={16}
        height={HeightCard.md}
        radius={CardRadius.md}
        size="md"
      >
        <Flex gap={"lg"} justify={"center"}>
          <Button
            leftIcon={<IoMdEye size={16} />}
            onClick={() => handleModal(false)}
            loading={false}
            sx={{ minWidth: 150 }}
          >
            View
          </Button>
          <Button
            leftIcon={<MdDownload size={16} />}
            onClick={() => handleModal(true)}
            loading={false}
            sx={{ minWidth: 150 }}
          >
            Download
          </Button>
        </Flex>
      </ActionCard>
    </div>
  );
}

export default memo(CardReport);
